export const home = {
  btn_signin: "Connexion",
  btn_signup: "Créer un compte",
  txt_header_section_1: "Votre outil de",
  txt_header_section_2: "Facturation",
  txt_description:
    "Nous définissons le problème, l'objectif et élaborons une proposition pour l'utilisateur, une fois que nous avons compris ses besoins. ",
  info_innov_title: "Innovation",
  info_innov_description:
    "Nous offrons des solutions technologiques avancées pour simplifier votre processus de facturation.",
  info_simplicity_title: "Simplicité",
  info_simplicity_description:
    "Nous mettons un point d'honneur à rendre la gestion de la facturation facile et accessible pour tous.",
  info_transp_title: "Transparence",
  info_transp_description:
    "Nous assurons une transparence totale dans vos processus de facturation pour éviter toute ambiguïté.",
  about_us_title: "Qui sommes-nous !",
  about_us_description:
    "Nous offrons des solutions technologiques avancées pour simplifier votre processus de facturation. Nous offrons des solutions technologiques avancées pour simplifier votre processus de facturation. Nous offrons des solutions technologiques avancées pour simplifier votre processus de facturation. Nous offrons des solutions technologiques avancées pour simplifier votre processus de facturation.",
  service_title: "Nos Services",
  service_sub_title: "Fonctionnalité",

  service_title1: "Simplifier votre facturation",
  service_title2: "commensez des maintenant",
  create_account: "Créér un compte",
  txt_service_adjec: "Rapide et gratuit",

  facture_title: "Transformez votre gestion de factures en quelques clics",
  facture_sub_title:
    "Adoptez la solution tout-en-un pour une gestion optimale de vos factures.",

  faq_title: "Questions fréquemment posées (FAQ)",
  faq_1_question: "Qu'est-ce qu'un logiciel de facturation ?",
  faq_1_res: "Qu'est-ce qu'un logiciel de facturation ?",

  faq_2_question: "Puis-je personnaliser mes factures ?",
  faq_2_res: "Qu'est-ce qu'un logiciel de facturation ?",

  faq_3_question: "Comment suivre mes paiements ?",
  faq_3_res: "Qu'est-ce qu'un logiciel de facturation ?",

  faq_4_question: "Le logiciel est-il sécurisé?",
  faq_4_res: "Contactez-nous ! Nous sommes là pour vous aider à chaque étape.",

  simple_pricing: "Tarification simple pour votre entreprise",
  simple_pricing_desc:
    "Nous proposons plusieurs formules puissantes pour mettre en valeur votre entreprise et vous faire connaître en tant qu'entrepreneure créative. Tout ce dont vous avez besoin.",
  bill_monthly: "Facturation mensuelle",
  bill_annualy: "Facturation annuelle",

  facturation_title: "Simplifiez votre facturation, commencez dés maintenant !",
  facturation_desc:
    "Gagnez du temps et réduisez les erreurs avec notre logiciel de facturation intuitif. Essayez-le gratuitement et découvrez une gestion simplifiée de vos finances.",
  facturation_sub_title: " Rapide et gratuit",
  footer_description:
    "Economisez l’abonnement de vos services de facturation et de CRM actuels, notre service est entièrement gratuit.",
  footer_information: "Informations",
  footer_support: "Support",
  footer_legal: "Juridique",
  footer_resources: "Ressources",

  footer_certification: "Certification",
  footer_how_it_works: "Comment ça marche ?",
  footer_cost: "Combien ça coute ?",

  footer_help: "Aide",
  footer_contact: "Contact",
  footer_blog: "Blog",

  footer_terms: "CGU",
  footer_privacy: "Politique de confidentialité",
  footer_legal_notice: "Mentions légales",

  footer_e_invoice: "Facture électronique",
  footer_billing_software: "Logiciel de facturation",
  footer_make_invoice: "Faire une facture",
};
